import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { AnimatePresence } from 'framer-motion';
import { useLlm } from '../../../useLlm/useLlm.js';

const Stream = _ref => {
  let {
    index,
    className
  } = _ref;
  const label = useLabel();
  const {
    BusyIndicator,
    ChunkWrapper
  } = useLlm(state => state.components);
  const chunks = useLlm(state => state.chunks);
  return jsx(Fragment, {
    children: chunks && jsx(Fragment, {
      children: jsx("div", {
        className: className || 'llm__message llm__message--assistant',
        role: "region",
        "aria-label": label('llm.answer'),
        children: jsxs(AnimatePresence, {
          children: [chunks.map((chunk, c) => jsx(ChunkWrapper, {
            className: `llm__inner llm__inner--${chunk.type}`,
            item: chunk,
            chunkIndex: c,
            index: index,
            total: index + 1,
            role: "assistant",
            stream: true
          }, `llm-message-${index}-chunk-${c}`)), jsx(BusyIndicator, {})]
        })
      })
    })
  });
};

export { Stream };
//# sourceMappingURL=stream.js.map
